import { Guid, Nillable } from '@web/utils';
import {
  OrderShipmentRefundSummary,
  ShipmentStatus,
  ShippingMethodCode,
} from '@web/shared/module/shop';
import { AdminOrderShippingAddress } from './admin-order-shipping-address';
import { AdminShipmentSizeType } from '../enums/admin-shipment-size-type';
import { AdminOrderShipmentComponentGroup } from './admin-order-shipment-component-group';

export class AdminOrderShipment {
  public constructor(
    private readonly data: {
      canBeSent: boolean;
      canBeDeleted: boolean;
      canBeEdited: boolean;
      id: Guid;
      status: ShipmentStatus;
      price: number;
      createdAt: Date;
      methodId: Guid;
      methodName: string;
      methodCode: ShippingMethodCode;
      address: AdminOrderShippingAddress;
      trackingUrl?: Nillable<string>;
      packageSize: AdminShipmentSizeType;
      comment?: Nillable<string>;
      scheduledShippingDate?: Nillable<Date>;
      componentGroups: AdminOrderShipmentComponentGroup[];
      refundSummary?: Nillable<OrderShipmentRefundSummary>;
    },
  ) {}

  public get canBeSent(): boolean {
    return this.data.canBeSent;
  }

  public get canBeDeleted(): boolean {
    return this.data.canBeDeleted;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get status(): ShipmentStatus {
    return this.data.status;
  }

  public get price(): number {
    return this.data.price;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get methodId(): Guid {
    return this.data.methodId;
  }

  public get methodName(): string {
    return this.data.methodName;
  }

  public get methodCode(): ShippingMethodCode {
    return this.data.methodCode;
  }

  public get address(): AdminOrderShippingAddress {
    return this.data.address;
  }

  public get trackingUrl(): Nillable<string> {
    return this.data.trackingUrl;
  }

  public get isSent(): boolean {
    return this.status === ShipmentStatus.Sent;
  }

  public get packageSize(): AdminShipmentSizeType {
    return this.data.packageSize;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get scheduledShippingDate(): Nillable<Date> {
    return this.data.scheduledShippingDate;
  }

  public get componentGroups(): AdminOrderShipmentComponentGroup[] {
    return this.data.componentGroups;
  }

  public get refundSummary(): Nillable<OrderShipmentRefundSummary> {
    return this.data.refundSummary;
  }

  public get isDeleted(): boolean {
    return this.status === ShipmentStatus.Deleted;
  }
}
